import React, { PropTypes, Component } from 'react';
class Carousel extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  render() {
    if (!Object.keys(this.props.entities).length) {
      return null;
    }

    var entities = this.props.entities;
    var carouselImages = entities.imagejson;
    carouselImages = JSON.parse(carouselImages);

    return (
      <div className="carousel-container" onLoad={ this.carousel.bind(this) }>
        <div className="carousel">
          <i onClick={ this.carouselUp.bind(this) } className="sprite-red sprite-Left-Chevron-Copy carousel-uparrow"></i>
          <div style={ { "height": "30em", "overflow": "hidden", "width": "100%" } }>
            <div id="carousel-thumbnail">
              { carouselImages.map(function(entity, index) {
                  return (
                    <div className="carousel-nav" data-index={ index }>
                      <img className="carousel-image" id={ "indicator" + index } src={ carouselImages[index] } />
                    </div>
                    );
                }) }
            </div>
          </div>
          <i onClick={ this.carouselBottom.bind(this) } className="sprite-red sprite-Left-Chevron-Copy carousel-bottomarrow"></i>
        </div>
        { carouselImages.map(function(entity, index) {
            return (
              <div className="leftitem-container" id={ "carousel" + index }>
                <img className="carousel-image" src={ "" + carouselImages[index] } />
              </div>
              );
          }) }
      </div>
      );
  }

  carousel() {
    var item;
    var i = 0;
    var tb = 0;
    var intervals = {};
    intervals["Interval"] = start_animation();
    $('#carousel0').fadeIn();
    $('#indicator0').addClass('activeSlider');
    $('#pagination0').addClass('activeindicator');
    //carousel_slider();
    function stop_animation(intervalArr) {
      for (i in intervalArr) {
        clearTimeout(item);
      }
      clearTimeout(item);
    }
    function start_animation() {
      stop_animation();
      item = setTimeout(function() {
        carousel1();
      }, 5000);
      return item;
    }
    $('.carousel-nav').on('click', function(e) {
      e.preventDefault();
      stop_animation(intervals);
      var index = $(this).data("index");
      $('#pagination' + tb.toString() + '').removeClass('activeindicator');
      $('#indicator' + tb.toString() + '').removeClass('activeSlider');
      $("#carousel" + tb.toString()).fadeOut();
      $("#carousel" + index.toString()).fadeIn();
      $('#indicator' + index.toString()).addClass('activeSlider');
      $('#pagination' + index.toString()).addClass('activeindicator');
      tb = index;
      $('.carousel-container').mouseout(function() {
        start_animation();
      });
    });
    function carousel1() {
      var carouselLength = $('#carousel-thumbnail').children().size();
      if (tb == carouselLength - 1) {
        $('#carousel' + tb + '').fadeOut();
        $('#carousel0').fadeIn();
        $('#indicator' + tb + '').removeClass('activeSlider');
        $('#pagination' + tb + '').removeClass('activeindicator');
        $('#indicator0').addClass('activeSlider');
        $('#pagination0').addClass('activeindicator');
        tb = 0;
      } else {
        $('#carousel' + tb + '').fadeOut();
        $('#indicator' + tb + '').removeClass('activeSlider');
        $('#pagination' + tb + '').removeClass('activeindicator');
        if (tb < carouselLength) {
          tb++;
        }
        $('#carousel' + tb + '').fadeIn();
        $('#indicator' + tb + '').addClass('activeSlider');
        $('#pagination' + tb + '').addClass('activeindicator');
      }
      start_animation();
    }
  }
  carouselUp() {
    var thumbnailheight = $('#carousel-thumbnail').children().size();
    var carouselheight = $('.carousel-nav').height() * 5 + 20;
    var carouselposition = $('#carousel-thumbnail').css('margin-top');
    carouselposition = carouselposition.slice(0, -2);
    if (carouselposition <= -carouselheight) {
      carouselposition = carouselheight + parseInt(carouselposition);
      if (carouselposition >= -carouselheight) {
        $('#carousel-thumbnail').animate({
          "margin-top": +carouselposition + "px"
        }, "slow");
      }
    } else {
      $('#carousel-thumbnail').animate({
        "margin-top": "0px"
      }, "slow");
    }
  }
  carouselBottom() {
    var thumbnailheight = $('#carousel-thumbnail').children().size();
    var carouselheight = $('.carousel-nav').height() * 5 + 20;
    var carouselposition = $('#carousel-thumbnail').css('margin-top');
    carouselposition = carouselposition.slice(0, -2);
    if (carouselposition <= -carouselheight) {
      carouselposition -= carouselheight;
      if (carouselposition >= -carouselheight) {
        $('#carousel-thumbnail').animate({
          "margin-top": +carouselposition + "px"
        }, "slow");
      }
    } else {
      $('#carousel-thumbnail').animate({
        "margin-top": "-" + carouselheight + "px"
      }, "slow");
    }
  }
}

module.exports = Carousel;


// WEBPACK FOOTER //
// ./src/components/Carousel.js